import { isAbUseExperimentGroup } from './isAbUseExperimentGroup';
import { IAbUseExperiment } from '../types/abUseExperiments';

export const OFFERS_FROM_HISTORY = 'offers_from_history';

export const isOffersFromHistoryExperiment = (experiments: IAbUseExperiment[]): boolean => {
  return isAbUseExperimentGroup(experiments, OFFERS_FROM_HISTORY, 'B');
};
